"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TONICVaultV2Factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "poolId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "multiplier",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lockPeriod",
                type: "uint256",
            },
        ],
        name: "AddPool",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "pid",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "stakeId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "weightedAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "unlockTimestamp",
                type: "uint256",
            },
        ],
        name: "Deposit",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "poolId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "multiplier",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lockPeriod",
                type: "uint256",
            },
        ],
        name: "SetPool",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "newRate",
                type: "uint256",
            },
        ],
        name: "SetVaultRewardRate",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "stakeId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "newPid",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newWeightedAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newUnlockTimestamp",
                type: "uint256",
            },
        ],
        name: "Upgrade",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "stakeId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "weightedAmount",
                type: "uint256",
            },
        ],
        name: "Withdraw",
        type: "event",
    },
    {
        inputs: [],
        name: "PRECISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "TONICVaultVersion",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "accTokenPerShare",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "activePoolMap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_multiplier",
                type: "uint32",
            },
            {
                internalType: "uint32",
                name: "_lockPeriod",
                type: "uint32",
            },
        ],
        name: "add",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "_stakeIds",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "_newPids",
                type: "uint256[]",
            },
        ],
        name: "batchUpgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "_stakeIds",
                type: "uint256[]",
            },
        ],
        name: "batchWithdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_pid",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "deposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_pid",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_holder",
                type: "address",
            },
        ],
        name: "depositFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "getUserInfo",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "poolId",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "weightedAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "stakeTimestamp",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "unlockTimestamp",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "active",
                        type: "bool",
                    },
                ],
                internalType: "struct TONICVaultV1.Stake[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_stakeId",
                type: "uint256",
            },
        ],
        name: "getUserStake",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "poolId",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "weightedAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "stakeTimestamp",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "unlockTimestamp",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "active",
                        type: "bool",
                    },
                ],
                internalType: "struct TONICVaultV1.Stake",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "_tonic",
                type: "address",
            },
            {
                internalType: "contract IERC20Upgradeable",
                name: "_xTonic",
                type: "address",
            },
            {
                internalType: "address",
                name: "_tectonicSocketContract",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lastRewardBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "pendingTONIC",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "poolInfo",
        outputs: [
            {
                internalType: "uint32",
                name: "multiplier",
                type: "uint32",
            },
            {
                internalType: "uint32",
                name: "lockPeriod",
                type: "uint32",
            },
            {
                internalType: "uint256",
                name: "totalStaked",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "poolLength",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_pid",
                type: "uint256",
            },
            {
                internalType: "uint32",
                name: "_multiplier",
                type: "uint32",
            },
            {
                internalType: "uint32",
                name: "_lockPeriod",
                type: "uint32",
            },
        ],
        name: "set",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newRate",
                type: "uint256",
            },
        ],
        name: "setVaultRewardRate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tectonicSocketContract",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tonic",
        outputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_stakeId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_newPid",
                type: "uint256",
            },
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "userInfo",
        outputs: [
            {
                internalType: "uint256",
                name: "weightedAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "rewardDebt",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "vaultRewardRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_stakeId",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "xTonic",
        outputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
class TONICVaultV2Factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TONICVaultV2Factory = TONICVaultV2Factory;
TONICVaultV2Factory.bytecode = _bytecode;
TONICVaultV2Factory.abi = _abi;
//# sourceMappingURL=TONICVaultV2Factory.js.map